<div class="main-container" style="height: 515px;" data-cy="check-out-ada-claim">
  <!--<div style="width: 1200px; height: 1200px;">-->
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;background-color: white" data-cy="check-out-ada-claim-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="check-out-ada-claim-header">
      <div class="section-header-title" data-cy="check-out-ada-claim-title">
        Claim Options
      </div>
    </div>
    <!--  MAIN AREA-->
    <div style="display:inline-block; padding-left: 20px; padding-top: 10px; padding-right: 20px;" data-cy="check-out-ada-claim-content">
      <div class="container" data-cy="check-out-ada-claim-fees-container">
        <label class="title" data-cy="check-out-ada-claim-fees-title">Fees to include</label>
        <br>
        <mat-radio-group data-cy="check-out-ada-claim-fees-group">
          <mat-radio-button value="AllFees" [checked]="true" (change)="radioAllFees($event)" data-cy="check-out-ada-claim-fees-all">All Fees Not Filed</mat-radio-button>
          <br>
          <mat-radio-button value="TodayOnly" (change)="radioAllFees($event)" data-cy="check-out-ada-claim-fees-today">Today's Fees Only</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="container" data-cy="check-out-ada-claim-insurance-container">
        <label class="title" data-cy="check-out-ada-claim-insurance-title">Insurance Type</label>
        <br>
        <mat-radio-group data-cy="check-out-ada-claim-insurance-group">
          <mat-radio-button value="Primary" [checked]="true" (change)="radioInsuranceType($event)" data-cy="check-out-ada-claim-insurance-primary">Primary</mat-radio-button>
          <br>
          <mat-radio-button value="Secondary" (change)="radioInsuranceType($event)" data-cy="check-out-ada-claim-insurance-secondary">Secondary</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="container" data-cy="check-out-ada-claim-assignment-container">
        <label class="title" data-cy="check-out-ada-claim-assignment-title">Assignment</label>
        <br>
        <mat-radio-group data-cy="check-out-ada-claim-assignment-group">
          <mat-radio-button value="Assigned" [checked]="true" data-cy="check-out-ada-claim-assignment-assigned">Assigned Claim</mat-radio-button>
          <br>
          <mat-radio-button value="noAssigned" data-cy="check-out-ada-claim-assignment-nonassigned">Non-Assigned Claim</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="check-out-ada-claim-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button class="tdo-button tdo-close" style="margin-right: 10px;" (click)="createClaim()" data-cy="check-out-ada-claim-ok-btn">OK</button>
      <button class="tdo-button tdo-close" style="margin-right: 10px;" (click)="cancelClaim()" data-cy="check-out-ada-claim-cancel-btn">Cancel</button>
    </div>
  </div>
</div>
